module.exports = __webpack_public_path__ + "img/mini_code.904a2ea9.jpg";